var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.5 -11.143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.287,13.62a5.041,5.041,0,0,1,7.129,7.129L29.447,32.717A5.031,5.031,0,0,1,26.871,34.1l-4.944.989a1.681,1.681,0,0,1-1.977-1.977l.989-4.944a5.031,5.031,0,0,1,1.378-2.576ZM39.04,16a1.683,1.683,0,0,0-2.377,0l-.636.636L38.4,19.009l.636-.636a1.683,1.683,0,0,0,0-2.377Zm-3.014,5.389L33.65,19.009l-8.956,8.955a1.677,1.677,0,0,0-.458.859l-.495,2.472,2.472-.495a1.678,1.678,0,0,0,.859-.458ZM17.542,15.647a1.682,1.682,0,0,0-1.681,1.681V37.493a1.682,1.682,0,0,0,1.681,1.681H37.707a1.682,1.682,0,0,0,1.681-1.681V27.411a1.68,1.68,0,1,1,3.36,0V37.493a5.042,5.042,0,0,1-5.041,5.041H17.542A5.042,5.042,0,0,1,12.5,37.493V17.328a5.042,5.042,0,0,1,5.041-5.041H27.624a1.68,1.68,0,1,1,0,3.36Z",
    transform: "translate(0 0)",
    fill: "#5196c3",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.625829bbaa77604cdf237b4b43827633.svg";
export { ForwardRef as ReactComponent };